export const nftContractAddress = "0x78319dcc9af63333cab5c5dec4b667f6d46a2358"